const getters = {
  getListSecurityQuestions: state => state.listSecurityQuestions,
  getCurrentSecurityQuestion: state => state.currentSecurityQuestion,
  getNotificationSettings: state => state.notificationSettings
}

export default getters
